import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-image-alt",
  "use": "icon-image-alt-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" class=\"bi bi-image-alt\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-image-alt\">\r\n  <path d=\"M10.648 6.646a.5.5 0 0 1 .577-.093l4.777 3.947V15a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-2l3.646-4.354a.5.5 0 0 1 .63-.062l2.66 2.773 3.71-4.71z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M4.5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/image-alt.svg
// module id = Tzl6
// module chunks = 60